import algoliasearch from "algoliasearch/lite";

import { firebase } from "astrid-firebase";
import createStore from "astrid-helpers/src/createStore";

import { onKnownUser } from "../../authentication/state/knownUser";

const getSecuredSearchApiKey = firebase.functions().httpsCallable("algolia-getSearchApiKey");

export const [
	getSearchClient,
	setAlgoliaSearchClient,
	useAlgoliaSearchClient,
	onSearchClient,
	resetAlgoliaSearchClient,
] = createStore([undefined, false, undefined]);

// The key is refused to users without access
onKnownUser(async (known) => {
	if (!known) {
		resetAlgoliaSearchClient();
		return;
	}

	setAlgoliaSearchClient([undefined, true, undefined]);

	try {
		const { data } = await getSecuredSearchApiKey();
		const { id, key } = data;

		const client = algoliasearch(id, key);

		setAlgoliaSearchClient([client, false, undefined]);
	} catch (error) {
		console.error(error);

		setAlgoliaSearchClient([undefined, false, error]);
	}
});
